import { render, staticRenderFns } from "./Section6thIm.vue?vue&type=template&id=7b8723f3&scoped=true&"
import script from "./Section6thIm.vue?vue&type=script&lang=js&"
export * from "./Section6thIm.vue?vue&type=script&lang=js&"
import style0 from "./Section6thIm.vue?vue&type=style&index=0&id=7b8723f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8723f3",
  null
  
)

export default component.exports